'use client';

import Link from "next/link";

import Image from "../../components/Image.jsx";

import img1 from "../../assets/dcc.png";
import img2 from "../../assets/templete/helthcare-template.png";
import img3 from "../../assets/templete/educational-templete.png";
import img4 from "../../assets/templete/real-estate-templete.png";
import img5 from "../../assets/templete/ecommerce-templet.png";
import img6 from "../../assets/templete/event-templet.png";
import img7 from "../../assets/templete/TempleteWellness.png";
import img8 from "../../assets/templete/traveling-template.png";
import img9 from "../../assets/templete/restaurant-templete.png";
import img10 from "../../assets/templete/professional-services-templet.png";
import SecondaryTag from "../../components/Tags/SecondaryTag.jsx";
const templates = [
  {
    name: "Professional Services",
    path: "/templates/professional-services",
    img: img10,
  },
  { name: "Healthcare", path: "/templates/healthcare", img: img2 },
  { name: "Educational", path: "/templates/educational", img: img3 },
  { name: "Real Estate", path: "/templates/real-estate", img: img4 },
  { name: "E-Commerce", path: "/templates/e-commerce", img: img5 },
  { name: "Event Planning", path: "/templates/event-planning", img: img6 },
  {
    name: "Fitness & Wellness",
    path: "/templates/fitness-wellness",
    img: img7,
  },
  { name: "Startups", path: "/templates/tech-startups", img: img1 },
  {
    name: "Travel & Hospitality",
    path: "/templates/travel-hospitality",
    img: img8,
  },
  {
    name: "Restaurant Services",
    path: "/templates/restaurant-food",
    img: img9,
  },
].filter((template) => template.name && template.path); // Filter out empty values

export default function Templates() {
  return (
    <div className="mx-auto px-4">
      <div className="flex flex-col items-center justify-center mt-10 w-[240px] md:w-full mx-auto">
        <SecondaryTag text={"Templates"} />
        <h1 className=" text-color-1 text-center text-4xl lg:text-6xl font-medium leading-[normal] my-10">
          Build Smarter, Start Here
        </h1>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {templates.map((template, index) => (
          <div
            className="flex justify-center flex-wrap gap-12 pt-8"
            key={index}
          >
            <Card
              key={index}
              img={template.img}
              name={template.name}
              path={template.path}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
const Card = ({ img, name, path }) => {
  return (
    <Link
      href={path}
      rel="noopener noreferrer"
      className="flex flex-col items-center w-80 lg:w-96 gap-4 group cursor-pointer mx-3"
    >
      <div className="flex-col w-full justify-center items-start gap-3 flex">
        <Image
          loading="lazy"
          className="h-[172px] w-full max-w-[400px] object-cover rounded-lg group-hover:scale-105 grayscale-[85%] transition-all ease-in duration-500 group-hover:grayscale-[0%]"
          src={img}
          alt={name}
          height="172"
          width="320"
        />
      </div>
      <div className="self-stretch flex-col justify-start items-start gap-4 flex">
        <div className="text-color-1 text-lg font-normal leading-6">{name}</div>
        <div className="justify-start items-center gap-1 inline-flex"></div>
      </div>
    </Link>
  );
};
